import { render, staticRenderFns } from "./PanelDataTable.vue?vue&type=template&id=337bea76"
import script from "./PanelDataTable.vue?vue&type=script&lang=js"
export * from "./PanelDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports